import { useLocation } from "react-router";
import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import "../modal.css";
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import DeleteConfirmation from "../deleteConfirmation";
import Table from "./../Theme/Table.js";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Add from "./Add";
import Edit from "./Edit";
import Badge from "@mui/material/Badge";
import AddCredit from "./AddCredit";
import Spinner from "../Spinner";
import { useContext } from "react";
import { RoleContext } from "../RoleContext";
import { handleExportClick } from "../exportFile";
import { handleExportClickDriver } from "../exportDriverFile";
import { Checkbox, Modal } from "antd";

import ReactToPrint from "react-to-print";
import Driver from "../reports/Driver";
import DriverMultiStepForm from "./DriverMultiStepForm.js";
import { Box, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, FormGroup, List, ListItem, Stack, Typography } from "@mui/material";


import { Add as AddIcon, ImportExport, Tune } from '@mui/icons-material';
import ActionButtons from "./DriversListActionButton.js";
import Chip from '@mui/material/Chip';
import Tooltip from '@mui/material/Tooltip';
import { 
  Edit as EditIcon, 
  Delete as DeleteIcon,
  Visibility as VisibilityIcon,
  AddCircle as AddCircleIcon
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
const DriversList = () => {
  const location = useLocation();
  const printableRef = useRef(null);
  const navigate = useNavigate();

  const [drivers, setDrivers] = useState([]);
  const [id, setId] = useState(null);
  const [data, setData] = useState(null);
  let [loading, setLoading] = useState(true);

  const roleData = useContext(RoleContext);
  var role = JSON.parse(roleData);

  const getDrivers = async () => {
    try {
      const response = await axios
        .get("drivers/")
        .then((res) => {
          setDrivers(res.data);
          setLoading(false);
          // notify()
        })
        .catch((err) => {
          notifyError();
        });
    } catch (error) {
      notifyError();
    }
  };
  
  const showAddModal = () => {
    setDisplayAddModal(true);
  };

  const hideConfirmationModal = () => {
    setDisplayConfirmationModal(false);
  };
  const [deleteMessage, setDeleteMessage] = useState(null);
  const [displayAddModal, setDisplayAddModal] = useState(false);
  const [displayConfirmationModal, setDisplayConfirmationModal] =
    useState(false);
  const showDeleteModal = (id, name) => {
    setId(id);
    setDeleteMessage(`Are you sure you want to delete this driver`);
    setDisplayConfirmationModal(true);
  };
  const hideAddModal = () => {
    setDisplayAddModal(false);
  };
  const submitDelete = (id) => {
    console.log(id);
    deleteDriver(id);
    getDrivers();
    setDisplayConfirmationModal(false);
  };
  const deleteDriver = async (id) => {
    const response = await axios.delete("/driver/" + id, {
      data: { id: id },
    });
    getDrivers();
  };

  const showEditModal = (id) => {
    setId(id);

    axios.get("/driver/" + id, {}).then((res) => {
      console.log("====drivers==========", res.data);
      setData(res.data.driver);
      setDisplayEditModal(true);
    });
  };
  const [displayEditModal, setDisplayEditModal] = useState(false);
  const hideEditModal = () => {
    setDisplayEditModal(false);
  };

  const showAddCreditModal = (id) => {
    setId(id);

    axios.get("/driver/" + id, {}).then((res) => {
      setData(res.data.driver);
      setDisplayAddCreditModal(true);
    });
  };
  const [displayAddCreditModal, setDisplayAddCreditModal] = useState(false);
  const hideAddCreditModal = () => {
    setDisplayAddCreditModal(false);
  };

  const edit = "driver";
  const detail = "viewDriver";

  const notify = () =>
    toast.success("Drivers list loaded.", {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });

  const notifyError = () =>
    toast.error("Something went wrong ...", {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  useEffect(() => {
    getDrivers();
  }, [location.key]);
 const columns = React.useMemo(
  () => [
    {
      Header: "Name",
      columns: [
        {
          Header: "ID",
          accessor: "id",
        },
        {
          Header: "First Name",
          accessor: "firstName",
        },
        {
          Header: "Last Name",
          accessor: "lastName",
        },
        {
          Header: "Gender",
          accessor: "gender",
        },
      ],
    },
    {
      Header: "Info",
      columns: [
        {
          Header: "Phone",
          accessor: "phoneNumber",
        },
        {
          Header: "Address",
          accessor: "address",
        },
        
        {
          Header: "Rating",
          accessor: "rating",
        },
        // {
        //   Header: "canSpeak",
        //   accessor: "canSpeak",
        // },
        {
          Header: "Balance",
          accessor: "balance",
        },
        {
          Header: "Pocket",
          accessor: "pocket",
        },
{
          Header: "Ambulance Company",
          accessor: "driversAmbulanceCompany.company_name",
          Cell: ({ value }) => value ? value : <span style={{ color: 'gray' }}>N/A</span>,
        },

        {

          Header: "Status",
          accessor: "status",
          disableFilters: true,
          Cell: (row) => {
            const status = row.cell.row.original.status || "Active";
            return (
              <Chip 
                label={status} 
                color={status === "Active" ? "success" : "warning"}
                variant="filled"
                sx={{
                  fontWeight: 'bold',
                  borderRadius: '8px',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  boxShadow: status === "Active" 
                    ? '0 2px 4px rgba(0,255,0,0.2)' 
                    : '0 2px 4px rgba(255,165,0,0.2)'
                }}
              />
            );
          },
        },
        {
          Header: "Action",
          accessor: "action",
          disableFilters: true,
          Cell: (row) => (
            <div style={{ 
              display: "flex", 
              gap: "15px", 
              alignItems: 'center' 
            }}>
              {role.filter(e => e.perm_name === "add_driver_pocket").length > 0 && (
                <Tooltip title="Add Credit">
                  <span>
                    <AddCircleIcon 
                      color="primary" 
                      sx={{ 
                        cursor: 'pointer',
                        transition: 'transform 0.2s',
                        '&:hover': {
                          transform: 'scale(1.2)',
                          color: '#1e40af'
                        }
                      }}
                      onClick={() => showAddCreditModal(row.cell.row.original.id)}
                    />
                  </span>
                </Tooltip>
              )}
              
              {role.filter(e => e.perm_name === "edit_driver").length > 0 && (
                <Tooltip title="Edit Driver   ">
                  <span>
                    <EditIcon 
                      color="primary" 
                      sx={{ 
                        cursor: 'pointer',
                        transition: 'transform 0.2s',
                        '&:hover': {
                          transform: 'scale(1.2)',
                          color: '#1e40af'
                        }
                      }}
                      onClick={() => showEditModal(row.cell.row.original.id)}
                    />
                  </span>
                </Tooltip>
              )}
              
              {role.filter(e => e.perm_name === "view_driver").length > 0 && (
                <Tooltip title="View Driver Details ">
                  <span>
                    <VisibilityIcon 
                      color="success" 
                      sx={{ 
                        cursor: 'pointer',
                        transition: 'transform 0.2s',
                        '&:hover': {
                          transform: 'scale(1.2)',
                          color: '#16a34a'
                        }
                      }}
                      onClick={() => navigate(`/viewDriver/${row.cell.row.original.id}`)}
                    />
                  </span>
                </Tooltip>
              )}
              
              {role.filter(e => e.perm_name === "delete_driver").length > 0 && (
                <Tooltip title="Delete Driver">
                  <span>
                    <DeleteIcon 
                      color="error" 
                      sx={{ 
                        cursor: 'pointer',
                        transition: 'transform 0.2s',
                        '&:hover': {
                          transform: 'scale(1.2)',
                          color: '#ff0000'
                        }
                      }}
                      onClick={() => showDeleteModal(row.cell.row.original.id)}
                    />
                  </span>
                </Tooltip>
              )}
            </div>
          ),
        },
      ],
    },
  ],
  [role]
);

  const columns_expo = React.useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
      },
      {
        Header: "First Name",
        accessor: "firstName",
      },
      {
        Header: "Last Name",
        accessor: "lastName",
      },
      {
        Header: "Gender",
        accessor: "gender",
      },
      {
        Header: "Phone",
        accessor: "phoneNumber",
      },
      {
        Header: "Address",
        accessor: "address",
      },
      {
        Header: "Rating",
        accessor: "rating",
      },
      {
        Header: "Balance",
        accessor: "balance",
      },
    //   {
    //   Header: "canSpeak",
    //   accessor: "canSpeak",
    // },
      {
        Header: "Pocket",
        accessor: "pocket",
      },
    ],
    []
  );
  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const [selectedColumns, setSelectedColumns] = useState(
    columns_expo.map((column) => column.Header)
  );

  const handleOkModal = () => {
    console.log("handleOkModal called");
    setIsModalVisible(false);
    handleExportClickDriver(
      drivers,
      columns_expo,
      selectedColumns,
      "Drivers",
      "drivers.pdf"
    );
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };
  // Inside your component
  function handleColumnToggle(columnHeader) {
    setSelectedColumns((prevSelectedColumns) => {
      if (prevSelectedColumns.includes(columnHeader)) {
        return prevSelectedColumns.filter((col) => col !== columnHeader);
      } else {
        return [...prevSelectedColumns, columnHeader];
      }
    });
  }
const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedColumns(columns_expo.map((column) => column.Header));
    } else {
      setSelectedColumns([]);
    }
  };

  const prRef = useRef(null);
  const [isPrintableComponentVisible, setIsPrintableComponentVisible] =
    useState(false);

  const handlePrintButtonClick = () => {
    setIsPrintableComponentVisible(true);
  };

  return (
    <div className="content-wrappers" style={{ marginTop: '-60px' }}>
    <div style={{marginTop: "20px"}} className="content-wrappers">
      <br />
      <br />
      <ToastContainer />

      <section className="content" ref={printableRef}>
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="card">
                 <ActionButtons
                  role={role}
                 showModal ={showModal}
                  showAddModal={showAddModal}
                  handlePrintButtonClick={handlePrintButtonClick}
                />
                  



                  <Modal
                  style={{marginTop: "60px"}}
                      title="Select Columns to Export"
                      visible={isModalVisible}
                      onOk={handleOkModal}
                      onCancel={handleCancel}
                      footer={[
                        <Button key="cancel" onClick={handleCancel}>
                          Cancel
                        </Button>,
                        <Button
                          style={{ marginLeft: "10px" }}
                          key="ok"
                          type="primary"
                          onClick={handleOkModal}
                        >
                          OK
                        </Button>,
                      ]}
                    >
                      <div style={{ marginBottom: "20px" }}>
                        {columns_expo.map((column) => (
                          <div
                            key={column.Header}
                            style={{ marginBottom: "10px" }}
                          >
                            <Checkbox
                              checked={selectedColumns.includes(column.Header)}
                              onChange={() => handleColumnToggle(column.Header)}
                              style={{ marginRight: "10px", fontSize: "16px" }}
                            >
                              {column.Header}
                            </Checkbox>
                          </div>
                        ))}
                      </div>
                    </Modal>
                 <div className="card-body">
                  {loading && (
                    <div>
                      <Spinner />
                    </div>
                  )}
                  {!loading && (
                    <Table
                      columns={columns}
                      data={drivers}
                      edit={edit}
                      detail={detail}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <DeleteConfirmation
        showModal={displayConfirmationModal}
        confirmModal={submitDelete}
        hideModal={hideConfirmationModal}
        id={id}
        message={deleteMessage}
      />
      {/* <Add showModal={displayAddModal} hideModal={hideAddModal} />
      {displayEditModal == true && (
        <Edit
          id={id}
          data={data}
          getDrivers={getDrivers}
          showModal={displayEditModal}
          hideModal={hideEditModal}
        />
      )} */}

      <DriverMultiStepForm
        showModal={displayAddModal}
        hideModal={hideAddModal}
        mode="add"
        refreshDrivers={getDrivers}
      />
      {
        displayEditModal == true && (
            <DriverMultiStepForm
              showModal={displayEditModal}
              hideModal={hideEditModal}
              mode="edit"
              initialData={data}
              refreshDrivers={getDrivers}
          />
        )
      }



      {displayAddCreditModal == true && (
        <AddCredit
          getDrivers={getDrivers}
          id={id}
          data={data}
          showModal={displayAddCreditModal}
          hideModal={hideAddCreditModal}
        />
      )}
    </div>
    </div>
  );
};

export default DriversList;
